module.exports = __webpack_public_path__ + "img/concrete-building-column-with-carvings-3259486.54e0e666.jpg";